import React, { useState } from 'react';
import ProductCard from '../components/ProductCard';
import { products, categories } from '../data/products';
import './Collections.css';

const sortOptions = ["Default", "Price: Low to High", "Price: High to Low", "Newest"];

export default function Collections() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [sort, setSort] = useState("Default");
  const [search, setSearch] = useState("");

  let filtered = products.filter(p =>
    (activeCategory === "All" || p.category === activeCategory) &&
    (search === "" || p.name.toLowerCase().includes(search.toLowerCase()))
  );

  if (sort === "Price: Low to High") filtered = [...filtered].sort((a, b) => a.price - b.price);
  if (sort === "Price: High to Low") filtered = [...filtered].sort((a, b) => b.price - a.price);
  if (sort === "Newest") filtered = [...filtered].reverse();

  return (
    <div className="collections-page page-wrapper">
      <div className="collections-hero">
        <p className="section-label">Our Heritage</p>
        <h1>All Collections</h1>
        <p className="collections-sub">Discover timeless Indian couture, crafted with heart</p>
      </div>

      <div className="collections-toolbar">
        <div className="cat-filters">
          {categories.map(cat => (
            <button
              key={cat}
              className={`cat-filter-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="toolbar-right">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="search-input"
          />
          <select value={sort} onChange={e => setSort(e.target.value)} className="sort-select">
            {sortOptions.map(o => <option key={o}>{o}</option>)}
          </select>
        </div>
      </div>

      <div className="collections-count">
        Showing {filtered.length} of {products.length} pieces
      </div>

      {filtered.length === 0 ? (
        <div className="no-results">
          <p>No pieces found. Try a different search.</p>
        </div>
      ) : (
        <div className="collections-grid">
          {filtered.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
